import styled from 'styled-components';
import { Image } from '../../../../raw-components/image/image';

export const GameBadgeDefaultBox = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  height: 24%;
  width: 23%;
`;
